/*
 *  jquery-ckpromos
 *  A jQuery plugin to dynamically replace content from data
 *  for use with ck-cms
 *  usage: $(document).ckpromos();
 *  Plugin is self-initializing, and self-contained
 *  copyright 2015-2020 CardKingdom
 */
;(function ($, window, document, undefined) {
  "use strict";

  // Create the defaults once
  const pluginName = "ckpromos";

  // plugin constructor
  function Plugin() {
    this.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    init: function () {
      let plug = this;

      $(document).on('dataLoaded:ckpromos', function (evt, data) {
        let currentPage = (window.location.pathname).toLowerCase();
        if (currentPage !== '/') { //dont let plugin stomp over homepage vue rendering
          plug.updatePromos(data);
        }
        plug.displayCkHelp(data);
      });

      plug.loadData();

    },
    displayCkHelp: function (data) {
      let plug = this;
      let helpData = data.ckHelp;
      let $selector, identifier;
      if (typeof helpData !== 'undefined' && helpData.length > 0) {
        for (let i = helpData.length - 1; i >= 0; i--) {
          $selector = $(helpData[i].selector);
          if ($selector.length === 1) {
            identifier = 'ckHelpId' + i;
            let _newE = $('<span class="ckHelp ' + helpData[i].position + ' glyphicon glyphicon-question-sign" data-helpid="' + identifier + '"></span>');
            $selector.append(_newE);
            let _helpE = $('<div id="' + identifier + '" class="ckTooltip">' + helpData[i].content + '</div>');
            $('body').append(_helpE);
          }
        }
        plug.initCKHelpInteractivity();
      }

    },
    updatePromos: function (data) {
      let plug = this;
      let pageMatch, targetPage, promo;
      /* cycle thru all promos, if selectors and page match update image and add link */

      for (let promoIndex = (data.promos).length - 1; promoIndex >= 0; promoIndex--) {
        promo = (data.promos)[promoIndex];
        targetPage = (promo.preview_page).replace(/&amp;/g, '&').toLowerCase();
        pageMatch = plug.checkForPageMatch(promo, targetPage);

        if ((targetPage.length === 0 || pageMatch === true)
            && $(promo.selector).length > 0) {
          if (typeof promo.image_url === 'undefined'
              && typeof promo.title === 'undefined'
              && typeof promo.flavorText === 'undefined'
              && typeof promo.html_blob === 'undefined'
              && typeof promo.embeddedVideoKey === 'undefined') {
            $(promo.selector).css({'display': 'none'});
          } else {
            $(promo.selector).css({'display': 'block'}).addClass('hasContent');

            //if this has a customClass, add it to selector
            if (typeof promo.customClass !== 'undefined' && (promo.customClass).length > 0) {
              $(promo.selector).addClass(promo.customClass);
            }

            //if there is a link url
            if (typeof promo.link_url !== 'undefined' && (promo.link_url).length > 0) {
              let link_url = promo.link_url;
              let cktag = promo.description || '';
              if (link_url.length > 0) {
                link_url = link_url.replace('&amp;', '&');
                if ($(promo.selector).find('>a').length > 0) {
                  $(promo.selector).find('>a').attr({"href": link_url, "data-cktag": cktag});
                } else {
                  $(promo.selector).find('.wrapForBorder > a').attr({"href": link_url, "data-cktag": cktag});
                }
              }
            }

            //if there is an image url
            if (typeof promo.image_url !== 'undefined' && (promo.image_url).length > 3) {
              promo.alt_text  = promo.alt_text || promo.title || promo.description || '';
              let imgTag = '<img src="' + CMS_HOST + promo.image_url + '" alt="' + promo.alt_text + '">';
              $(promo.selector).find('.itemImage').css({'display': 'block'}).html(imgTag);
            }

            //if title, insert and show
            if (typeof promo.title !== 'undefined' && (promo.title).length > 0) {
              $(promo.selector).find('h3').css({'display': 'block'}).find('span').text(promo.title);
            }

            //if text, insert and show
            if (typeof promo.flavorText !== 'undefined' && (promo.flavorText).length > 0) {
              $(promo.selector).find('.text').css({'display': 'block'}).text(promo.flavorText);
            }

            //if custom html_blob insert
            if (typeof promo.html_blob !== 'undefined' && (promo.html_blob).length > 3) {
              promo.html_blob = promo.html_blob.replace(/\\&quot;/g, '&quot;');//fix qouble-quotes in content
              if ($(promo.selector).find('.specialContent').length > 0) {
                $(promo.selector).find('.specialContent').append(promo.html_blob);
              } else if ($(promo.selector).find('> a').length > 0) {
                $(promo.selector).find('> a').append(promo.html_blob);
              } else if ($(promo.selector).find('.wrapForBorder > a').length > 0) {
                $(promo.selector).find('.wrapForBorder > a').append(promo.html_blob);
              } else {
                $(promo.selector).append(promo.html_blob);
              }
            }

            if (typeof promo.contentType === 'string' && promo.contentType.length > 0) {
              plug.renderUniqueContentTypes(promo);
            }

          }
        }
      }
      $(document).trigger('promosBuilt:ckpromos');
    },
    renderUniqueContentTypes: function (promo) {
      let plug = this;
      switch (promo.contentType) {
        case 'customHeading':
          let headingSelector = promo.selector + ' h3';
          let newHeading = '<' + promo.customHTag + '>' + promo.title + '</' + promo.customHTag + '>';
          $(headingSelector).replaceWith(newHeading);
          $(promo.selector).addClass('noHoverFx');
          break;
        case 'embeddedVideo':
          let videoContainer = promo.selector + ' .itemImage';
          let youtubeCode = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + promo.embeddedVideoKey + '?rel=0&modestbranding=1" frameborder="0" allow="" allowfullscreen></iframe>\n';
          $(promo.selector).addClass('embeddedVideo');
          $(videoContainer).css({'display': 'block'}).html(youtubeCode);

          break;
        case 'pouncingPopup':
          let cookieName = 'ckShowPopupCount-' + promo.id
          let popupShownCount = (parseInt(plug.getCookie(cookieName))) ? (parseInt(plug.getCookie(cookieName))) : 0;
          let maxPopupCount = parseInt(promo.maxPopupCount);
          if (popupShownCount < maxPopupCount) {
            plug.showLightbox(promo);
            plug.setCookie(cookieName, ++popupShownCount, 365);
          }
          break;
        case 'productSlider':
          if (typeof promo.productSliderId === 'string' && promo.productSliderId.length > 0) {
            $(promo.selector).addClass('productSlider noHoverFx');
            let triggerEvent = 'setProductSlider' + promo.selector;
            $(document).trigger(triggerEvent, [promo.productSliderId, promo.productSliderType]);
          }
          break;
      }
    },
    checkForPageMatch: function (promo, targetPage) {
      let arrShowOnPages;
      let currentPage = (window.location.pathname).toLowerCase();
      if (targetPage.indexOf('||') < 0) { //check for multiple page delimiter
        if (targetPage === currentPage) {
          return true;
        }
      } else {
        arrShowOnPages = targetPage.split('||');
        for (let pageIndex = arrShowOnPages.length - 1; pageIndex >= 0; pageIndex--) {
          if (arrShowOnPages[pageIndex] === currentPage) {
            return true;
          }
        }
      }
      return false;
    },
    loadData: function () {
      let plug = this;
      let url = CMS_HOST + '/cms/json/ck_config.json?v='+ck.version;

      $.ajax({
        url: url,
        dataType: 'json',
        type: 'get',
        complete: function (data) {
          plug.promoListData = JSON.parse(data.responseText);
          $(document).trigger('dataLoaded:ckpromos', plug.promoListData);
        }
      });

    },
    setCookie: function (cname, cvalue, exdays) {
      let expires = '', cookieString = "";
      //if no exdays, expire with session
      if (typeof exdays === 'number') {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); //set for specifed time
        expires = 'expires=' + d.toUTCString();
      }
      document.cookie = (cname + '=' + cvalue + '; ' + expires + '; path=/');
    },

    getCookie: function (cname) {
      let name = cname + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    showLightbox: function (_this) {
      let image_url = $(_this).data('maxsrc') || _this.image_url;
      let lightboxElement = '<div class="lbWrapper"><div class="lbBackdrop"></div>';
      if (_this.link_url && _this.link_url.length > 0) {
        lightboxElement += '<a class="lbLink" href="' + _this.link_url + '" target="_blank"><div id="lbImage" class="lbImage"></div></a>';
      } else {
        lightboxElement += '<div id="lbImage" class="lbImage"></div>';
      }
      lightboxElement += '<div class="lbClose glyphicon glyphicon-remove"></div></div>';
      let loadingImage = new Image();
      loadingImage.onload = function () {
        let cssUrl = "url('" + this.src + "')";
        let cssHeight = this.height + 'px';
        let cssWidth = this.width + 'px';
        $('#lbImage').css({'background-image': cssUrl, 'height': cssHeight, 'width': cssWidth});
      };
      loadingImage.src = image_url;
      $('body').append(lightboxElement);
    },
    initCKHelpInteractivity: function () {
      $(document).on({
        mouseleave: function () {
          var _id = '#' + $(this).data('helpid');
          setTimeout(function () {
            if (typeof ck.tooltip == 'undefined') {
              $(_id).css({'display': 'none'});
            }
          }, 500);

        },
        click: function (e) {
          e.stopPropagation(); //in case element is inside a link..
          var _id = '#' + $(this).data('helpid');
          var _offset = $(this).offset();
          $(_id).css({'top': _offset.top, 'left': _offset.left}).toggle();
          if ($(this).hasClass('right')) {
            $(_id).addClass('right');
          }

        },
        touchend: function (e) {
          e.preventDefault();
          var _id = $(this).data('helpid');
          $('.ckTooltip').css({'display': 'none'});
          ck.showHelp = false;
          if (typeof _id !== 'undefined') {
            $('.ckTooltip').css({'display': 'none'});
            ck.showHelp = false;
            _id = '#' + _id;
            var _offset = $(this).offset();
            $(_id).css({'top': _offset.top, 'left': _offset.left}).toggle();
            if ($(this).hasClass('right')) {
              $(_id).addClass('right');
            }
            setTimeout(function () {
              ck.showHelp = true;
            }, 300);
          }

        }
      }, '.ckHelp');

      $(document).on({
        mouseenter: function () {
          ck.tooltip = this;
        },
        mouseleave: function () {
          ck.tooltip = undefined;
          $(this).css({'display': 'none'}); //.removeClass('shown')
        },
        click: function () {
          $('.ckTooltip').css({'display': 'none'});
          ck.showHelp = false;
        },
        touchend: function () {
          ck.showHelp = true;
          setTimeout(function () {
            $('.ckTooltip').css({'display': 'none'});
            ck.showHelp = false;
          }, 0);
        }
      }, '.ckTooltip');


    }

  });

  // plugin wrapper around the constructor, preventing multiple instances
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  };

})(jQuery, window, document);

//init self
$(function () {
  $(document).ckpromos();
});

